<mat-checkbox [checked]="table.isSelected(row)" (change)="table.toggleSelection(row)" (click)="$event.stopPropagation()"/>
